"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Destroyable = void 0;
var AlreadyDestroyedError_1 = require("./AlreadyDestroyedError");
var TeardownLogic_1 = require("./TeardownLogic");
/**
 * Generic implementation of the IDestroyable
 */
var Destroyable = /** @class */ (function () {
    function Destroyable() {
        // tslint:disable-next-line
        this._isDestroyed = false;
        this.subdestroyable = [];
    }
    /**
     * Chcek whether the given object is destroyable
     */
    Destroyable.isDestroyable = function (obj) {
        return obj && typeof obj.destroy === 'function' && typeof obj.isDestroyed === 'boolean';
    };
    Object.defineProperty(Destroyable.prototype, "isDestroyed", {
        /**
         * Is this object destroyed?
         */
        get: function () {
            return this._isDestroyed;
        },
        enumerable: false,
        configurable: true
    });
    Destroyable.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, subdestroyable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.assertNotDestroyed();
                        this._isDestroyed = true;
                        _i = 0, _a = this.subdestroyable;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        subdestroyable = _a[_i];
                        return [4 /*yield*/, TeardownLogic_1.teardown(subdestroyable)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Binds new registration with itself. This registration/destroyable will be destroyed with this.
     */
    Destroyable.prototype.addSubdestroyable = function () {
        var _a;
        var subdestroyable = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            subdestroyable[_i] = arguments[_i];
        }
        // TODO: Create remove counterpart to add
        (_a = this.subdestroyable).push.apply(_a, subdestroyable);
        return this;
    };
    /**
     * Checks, whether the object is not destroyed
     *
     * @param errorMessage Message that will replace default one before error
     */
    Destroyable.prototype.assertNotDestroyed = function (errorMessage) {
        if (errorMessage === void 0) { errorMessage = "This object is already destroyed."; }
        if (this._isDestroyed) {
            throw new AlreadyDestroyedError_1.AlreadyDestroyedError(errorMessage);
        }
    };
    return Destroyable;
}());
exports.Destroyable = Destroyable;
/*
 * TODO: Unite Registration and Destroyable
 */ 
//# sourceMappingURL=Destroyable.js.map